import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections, Objects} from "components";

import UserRoles from "constants/UserRoles";

const breadcrumbsStatic = [{
	name: 'Network Inspection Waivers',
	url: '/forms/network_inspection_waivers',
	icon: 'archive',
}];

export default class Network_Inspection_Waivers extends Framework.Components.View {

	render() {
		let {history,roles} = this.props;

		return (
			<div className="container-fluid">

				<Collections.MandatoryNetworkInspectionWaivers
					history={history}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
					regions={this.props.regions}
					showCSV={roles.includes(UserRoles.Admin)}
				/>

			</div>
		);
	}
}

